/*
  Lunveil — onde de survol des cartes produit.
  Une onde concentrique se propage depuis le point de contact (400 ms, ease-out).
  Ne fait rien si l'utilisateur préfère les animations réduites.
*/
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function spawnRipple(host, x, y) {
    if (reducedMotion.matches) return;

    var rect = host.getBoundingClientRect();
    var size = Math.max(rect.width, rect.height) * 2;
    var ripple = document.createElement('span');
    ripple.className = 'lunveil-ripple';
    ripple.style.width = size + 'px';
    ripple.style.height = size + 'px';
    ripple.style.left = (x - rect.left) + 'px';
    ripple.style.top = (y - rect.top) + 'px';
    host.appendChild(ripple);
    ripple.addEventListener('animationend', function () {
      ripple.remove();
    });
  }

  function onPointerEnter(event) {
    var host = event.currentTarget;
    spawnRipple(host, event.clientX, event.clientY);
  }

  function init() {
    document.querySelectorAll('.product-card, .card-product').forEach(function (card) {
      if (card.dataset.lunveilRipple) return;
      card.dataset.lunveilRipple = 'true';
      card.classList.add('lunveil-ripple-host');
      card.addEventListener('pointerenter', onPointerEnter);
    });
  }

  /*
    Vidéo de fond du hero : on ne la charge qu'après le premier rendu, pour que
    l'image reste le LCP. Sur connexion lente ou en économie de données, on ne
    la charge pas du tout — l'image de secours suffit.
  */
  function initHeroVideo() {
    var host = document.querySelector('[data-lunveil-hero-video]');
    if (!host || host.dataset.lunveilInit) return;
    host.dataset.lunveilInit = 'true';

    if (reducedMotion.matches) return;

    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;

    var video = host.querySelector('video');
    if (!video) return;

    var src = video.dataset.src;
    if (!src) return;

    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;

    var start = function () {
      // La source n'est posée qu'ici : tant qu'elle est absente, le navigateur
      // ne télécharge rien et l'image du hero reste seule à compter pour le LCP.
      video.src = src;
      video.preload = 'auto';
      video.load();
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      video.addEventListener('playing', function () {
        host.classList.add('is-playing');
      }, { once: true });
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(start, { timeout: 2500 });
    } else {
      setTimeout(start, 1200);
    }
  }

  function boot() {
    init();
    initHeroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', initHeroVideo);
  document.addEventListener('shopify:section:load', boot);
})();
